import React, { useEffect, useState } from 'react'
import { getRateApi } from '../../Api/BarestSupplierServices'
import LoadingComponet from '../LoadingComponet/LoadingComponet'
import StarRate from '../StarRate/StarRate'
import Style from './Performancepoints.module.css'
const Performancepoints = () => {
    const[data,setData]=useState()

    useEffect(()=>{
        getRateInformation()
    },[])

    const getRateInformation=async()=>{
        const result=await getRateApi()
        setData(result)
    }
    let loading=null
    if(data===undefined){
        return loading=<LoadingComponet/>
    }
    else{
        loading=
        <section className={Style.SupplierScoreHolder}>
            <h5>امتیاز طبق نظرسنجی:</h5>
            <div className={Style.StarRateHolder}>
                <StarRate rate={data.average}/>
            </div>
            <p>تعداد امتیاز ثبت شده: <span>{data.count}</span></p>
            <p>امتیاز به درصد: <span>{Math.round(data.average)*20}%</span></p>
            <p>امتیاز از 5 : <span>{Math.round(data.average)}</span></p>
        </section>  
    }
    return (
        <div className={Style.pageHolder}>
            <div className={Style.ImageHolder}><img src="/Assets/Images/Score/performancepoints.svg" alt="" /></div>
            {loading}
        </div>
    )
}
export default Performancepoints
